export const RATING_TOOLTIP =
  'Hier weden über die Auswahl einer Option gewichtete Werte für die initialen Bewertungskriterien eines Use-Cases bestimmt: ' +
  '1 = schlecht, 2 = mittelmäßig, 3 = gut, 4 = sehr gut ';
export const WORKSHOP_TOOLTIP =
  'Hier werden über die Auswahl einer Option gewichtete Werte für die Workshop-Bewertungskriterien eines Use-Cases bestimmt: ' +
  '1 = schlecht, 2 = mittelmäßig, 3 = gut, 4 = sehr gut ';
export const DEEPDIVE_TOOLTIP =
  'Hier befinden sich Freitextfelder für die einzelnen Deep-Dive Bewertungen ';
